import resso from 'resso';

export const themeStore = resso({ company: [], dept: [], isCompanyFinished: false, });
export const knowledgesStore = resso({ knowledges: [] });
export const userStore = resso({ userId: '', deptId: '', deptName: null, page: 1, pageSize: 100, token: '', waitForExamKnowledgeId: '', lineId: '' });
export const videoStore = resso({ videos: null, active: {} });